// extracted by mini-css-extract-plugin
export var fullWidthButton = "_gb-0";